import { formatDateMoment, setNumberWithPoint } from 'utils/utils'
import { Badge, Button } from 'avo-ui'
import icTrash from 'assets/images/ic-trash.svg'
import { ACTION_TYPE } from 'constants/constant'
import icEditYellow from 'assets/images/ic-edit-yellow.svg'

export const TABLE_FLASH_SALE = {
    name: 'Flash Sale',
    column: [
        {
            name: 'Nama',
            key: 'name',
            className: 'capitalize',
        },
        {
            name: 'Deskripsi',
            key: 'description',
        },
        {
            name: 'Total Produk',
            key: 'total_product',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
        {
            name: 'Updated At',
            key: 'updated_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={value} type={value} />,
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <div className={'flex space-x-3 justify-center'}>
                    <Button
                        type={'outline'}
                        title={'Edit'}
                        icon={icEditYellow}
                        disabled={!item?.is_update}
                        onClick={() => onClickItem({ id: item?.id, actionType: ACTION_TYPE.EDIT })}
                    />
                    <Button
                        type={'outline'}
                        title={'Delete'}
                        icon={icTrash}
                        disabled={!item?.is_delete}
                        onClick={() => onClickItem({ id: item?.id, actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}

export const FILTER_GIFT = [
    {
        title: 'status',
        key: 'status',
        list: [
            {
                name: 'publish',
                value: 'publish',
            },
            {
                name: 'draft',
                value: 'draft',
            },
        ],
    },
]
